import posthog from "posthog-js";
import { PostHogProvider } from "@posthog/react";

const token = import.meta.env.VITE_POSTHOG_PROJECT_TOKEN;

export function isCloudPath(pathname) {
    return pathname === "/cloud" || pathname.startsWith("/cloud/");
}

export function isNightwatchPath(pathname) {
    return pathname === "/nightwatch" || pathname.startsWith("/nightwatch/");
}

function isCapturedPath(pathname) {
    return isCloudPath(pathname) || isNightwatchPath(pathname);
}

function currentPathname() {
    return typeof window === "undefined" ? "" : window.location.pathname;
}

// PostHog is scoped to the /cloud marketing pages. Inertia is a single-page
// app, so the provider mounts once and stays mounted — capturing is gated at
// runtime via opt in/out instead of conditionally rendering the provider.
if (typeof window !== "undefined" && token) {
    posthog.init(token, {
        api_host: import.meta.env.VITE_POSTHOG_HOST || "https://us.i.posthog.com",
        defaults: "2026-01-30",
        capture_pageview: false,
        opt_out_capturing_by_default: !isCapturedPath(currentPathname()),
    });
}

// Toggle capturing as the visitor moves on and off /cloud or /nightwatch
export function syncPostHogCapture(pathname) {
    if (typeof window === "undefined" || !token) {
        return;
    }

    if (isCapturedPath(pathname)) {
        posthog.opt_in_capturing();
    } else {
        posthog.opt_out_capturing();
    }
}

export function capturePageView(pathname) {
    if (typeof window === "undefined" || !token) {
        return;
    }

    if (isCapturedPath(pathname)) {
        posthog.capture("$pageview");
    }
}

export function trackCloudNavigation(href) {
    if (!token || posthog.has_opted_out_capturing()) {
        return;
    }

    if (typeof href === "string" && href.includes("cloud.laravel.com")) {
        posthog.capture("Cloud Link Click", { href });
    }
}

export function PostHogApp({ children }) {
    if (!token) {
        return children;
    }

    return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
